var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A3",
    fillRule: "evenodd",
    d: "M17.87 4h-6.708c-1.175 0-2.13.956-2.13 2.13v2.902H6.13c-1.174 0-2.13.955-2.13 2.13v6.708C4 19.045 4.956 20 6.13 20h6.709c1.174 0 2.13-.956 2.13-2.13v-2.902h2.901c1.174 0 2.13-.956 2.13-2.13V6.132C20 4.956 19.045 4 17.87 4Zm-3.807 13.87c0 .676-.55 1.225-1.224 1.225h-6.71c-.675 0-1.223-.55-1.223-1.225v-6.709c0-.675.55-1.224 1.224-1.224H9.03v2.902c0 1.174.956 2.13 2.13 2.13h2.902v2.901Zm3.808-3.807c.675 0 1.224-.549 1.224-1.224V6.13c0-.675-.549-1.225-1.224-1.225h-6.71c-.674 0-1.223.55-1.223 1.225v6.708c0 .675.548 1.224 1.224 1.224h6.709Z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "copy_svg__a",
    width: 16,
    height: 16,
    x: 4,
    y: 4,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.87 4h-6.708c-1.175 0-2.13.956-2.13 2.13v2.902H6.13c-1.174 0-2.13.955-2.13 2.13v6.708C4 19.045 4.956 20 6.13 20h6.709c1.174 0 2.13-.956 2.13-2.13v-2.902h2.901c1.174 0 2.13-.956 2.13-2.13V6.132C20 4.956 19.045 4 17.87 4Zm-3.807 13.87c0 .676-.55 1.225-1.224 1.225h-6.71c-.675 0-1.223-.55-1.223-1.225v-6.709c0-.675.55-1.224 1.224-1.224H9.03v2.902c0 1.174.956 2.13 2.13 2.13h2.902v2.901Zm3.808-3.807c.675 0 1.224-.549 1.224-1.224V6.13c0-.675-.549-1.225-1.224-1.225h-6.71c-.674 0-1.223.55-1.223 1.225v6.708c0 .675.548 1.224 1.224 1.224h6.709Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A3",
    d: "M0 0h24v24H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8647a37d.svg";
export { ForwardRef as ReactComponent };